export class ContentChangedEvent {
  text: string;
  innerHTML: Node;
  currentParagraphText: string;
  /* current paragraph start position in the document */
  currentPargraphStartPos: number;
  /* current paragraph end position in the document */
  currentPargraphEndPos: number;
  redoCount: number;
  undoCount: number;
}
